import { render } from "./Variant_Protein.vue?vue&type=template&id=20620d57"
import script from "./Variant_Protein.vue?vue&type=script&lang=js"
export * from "./Variant_Protein.vue?vue&type=script&lang=js"

import "./Variant_Protein.vue?vue&type=style&index=0&id=20620d57&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__